//@flow

import {KeyFrameMetadataEntry, Point} from '../../autogenerated/ZoomBridge';
import construct from "@babel/runtime/helpers/esm/construct";

export class AssetAiData {
  getUuid(): string {
    throw new Error('Method No Implemented');
  }

  getProperties(): ?Map<string, string> {
    throw new Error('Method No Implemented');
  }

  getValue(): ?string {
    throw new Error('Method No Implemented');
  }

  getConfidence(): number {
    throw new Error('Method No Implemented');
  }

  getBoundingBox(): Array<BoundingBox> {
    throw new Error('Method No Implemented');
  }

  getTimeCode(): ?TimeCode {
    throw new Error('Method No Implemented');
  }

  getAiType(): ?string {
    throw new Error('Method No Implemented');
  }

  forEachProperty(callback: (propertyName: string, propertyValue: string, index: number) => void): void {
    let index: number = 0;
    if (this.getValue() != null) {
      const v = this.getValue();
      if (v) callback('value', v, index++);
    }
    // if (this.getConfidence() > 0) {
    //   callback('confidence', this.getConfidence() + '%', index++);
    // }

    const props: ?Map<string, string> = this.getProperties();
    if (props) {
      props.forEach(function (v: string, k: string) {
        callback(k, v, index++);
      });
    }
  }
}

export class TimeCode {
  _startTime: number;
  _endTime: number;

  constructor(startTime: number, endTime: number) {
    this._startTime = startTime;
    this._endTime = endTime;
  }

  getStartTime(): number {
    return this._startTime;
  }

  getEndTime(): number {
    return this._endTime;
  }
}

export class BoundingBox {
  getPoints(): Array<Point> {
    throw new Error('Method No Implemented');
  }
}


/*
export class CommonAiDataWrapperForTimeline {
  _assetAiData: AssetAiData;
  __cid: number;
  __id: number;
  _key: string;
  _isKeyFrameData: boolean;

  static createFromAssetAiData(data: AssetAiData, key: string): CommonAiDataWrapperForTimeline {
    new CommonAiDataWrapperForTimeline(
      key,
      data.getUuid(),
      false,
      data.getTimeCode() ? data.getTimeCode().getStartTime() : undefined,
      data.getTimeCode() ? data.getTimeCode().getEndTime() : undefined
    );
  }

  static createFromKeyFrameData(keyFrameMetadataEntry: KeyFrameMetadataEntry): CommonAiDataWrapperForTimeline {

  }

  constructor(key: string, id: string, keyframe: boolean, startTime: number, endTime: number) {
    this._id = id;
    this._key = key;
    this._isKeyFrameData = keyframe;
    this._startTime = startTime;
    this._endTime = endTime;
  }

  get value(): string {
    return this._assetAiData.getValue() || '';
  }

  get id(): string {
    return this._assetAiData.getUuid();
  }

  get _boundingBox(): Array<BoundingBox> {
    return this._assetAiData.getBoundingBox();
  }

  get _cid(): number {
    return this.__cid;
  }

  set _cid(cid: number): void {
    this.__cid = cid;
  }


  get _id(): number {
    return this.__id;
  }

  set _id(_id: number): void {
    this.__id = _id;
  }

  get isKeyFrameData(): number {
    return this._isKeyFrameData;
  }

  set isKeyFrameData(isKeyFrameData: boolean): void {
    this._isKeyFrameData = isKeyFrameData;
  }

  get key(): string {
    return this._name;
  }

  get startTimeMs(): number {
    if (this._assetAiData) {
      this._assetAiData.getTimeCode().getStartTime();
    }
    return 0;
  }

  get stopTimeMs(): number {
    if (this._assetAiData) {
      this._assetAiData.getTimeCode().getEndTime();
    }
    return 0;
  }
}*/
